var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenNewPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Open",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M349.363,342.364a.637.637,0,0,0-.636.636v5.091a.636.636,0,0,1-.636.636H337.909a.637.637,0,0,1-.636-.636V337.909a.636.636,0,0,1,.636-.636H343A.636.636,0,1,0,343,336h-5.091A1.909,1.909,0,0,0,336,337.909v10.182A1.909,1.909,0,0,0,337.909,350H348.09A1.909,1.909,0,0,0,350,348.091V343a.637.637,0,0,0-.636-.636Z",
    transform: "translate(-336 -336)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M604.109,337.269H605.8l-4.675,4.652a.632.632,0,0,0,0,.895.642.642,0,0,0,.9,0l4.636-4.595v1.587a.632.632,0,0,0,.187.449.641.641,0,0,0,.9,0,.632.632,0,0,0,.187-.449v-3.173a.632.632,0,0,0-.187-.449A.64.64,0,0,0,607.3,336h-3.193a.64.64,0,0,0-.553.317.631.631,0,0,0,0,.635.64.64,0,0,0,.553.317Z",
    transform: "translate(-593.941 -336)",
    fill: "#07b4e8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenNewPage);
export default __webpack_public_path__ + "static/media/openNewPage.0d4af77da16fb1d6a3d379928705e255.svg";
export { ForwardRef as ReactComponent };